import React, { useMemo } from 'react';
import { DropdownTheme, Dropdown, Card, DropdownOptionTextOverflow } from 'wix-ui-tpa/cssVars';
import { classes } from './ScheduledDeliverySelector.st.css';
import { useDeliverySectionData } from '../../../provider/useDeliverySectionContext';
import { dataHooks } from '@wix/data-hooks';
import { useLocaleKeys } from '../../../locale-keys/LocaleKeys';
export const ScheduledDeliverySelectorHook = dataHooks('ScheduledDeliverySelector');
export const ScheduledDeliverySelector = props => {
  const {
    deliveryOption
  } = props;
  const localeKeys = useLocaleKeys();
  const {
    selectedDeliveryOption,
    setDeliveryMethodId,
    isUpdatingShippingOption
  } = useDeliverySectionData();
  const dropdownOptions = useMemo(() => deliveryOption.options.map(option => {
    return {
      id: option.id,
      value: option.deliveryTime,
      isSelectable: true,
      textOverflow: DropdownOptionTextOverflow.wrap
    };
  }), [deliveryOption.options]);
  return /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/React.createElement(Card, {
    "data-hook": ScheduledDeliverySelectorHook.root(),
    className: classes.card
  }, /*#__PURE__*/React.createElement(Dropdown, {
    label: localeKeys.deliverySection.selectOption.label(),
    disabled: isUpdatingShippingOption,
    upgrade: true,
    initialSelectedId: selectedDeliveryOption == null ? void 0 : selectedDeliveryOption.id,
    "data-hook": ScheduledDeliverySelectorHook.dropdown(),
    onChange: option => setDeliveryMethodId(option.id, deliveryOption.groupId),
    theme: DropdownTheme.Box,
    options: dropdownOptions,
    className: classes.dropdown
  })));
};
//# sourceMappingURL=ScheduledDeliverySelector.js.map